import axios from 'axios';

const SchoolLevel = {
    namespaced: true,    
    actions: {
        CreateSchoolLevel({ rootState }, payload) {
            return new Promise((resolve, reject) => {  
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };                      
                axios.post(`${process.env.VUE_APP_ENV_API_URL}SchoolLevels/CreateSchoolLevel`, payload, { headers })
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        },    
        UpdateSchoolLevel({ rootState }, payload) {
            return new Promise((resolve, reject) => {  
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };                      
                axios.post(`${process.env.VUE_APP_ENV_API_URL}SchoolLevels/UpdateSchoolLevel`, payload, { headers })
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        },  
        GetSchoolLevels({ rootState },{SchoolTypeId}) {
            return new Promise((resolve, reject) => {  
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };                    
                axios.get(`${process.env.VUE_APP_ENV_API_URL}SchoolLevels/PortalGetSchoolLevels?SchoolTypeId=${SchoolTypeId}`, { headers })
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        }, 
        GetSchoolLevelById({ rootState },SchoolLevelId) {
            return new Promise((resolve, reject) => {  
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };                    
                axios.get(`${process.env.VUE_APP_ENV_API_URL}SchoolLevels/PortalGetByIdSchoolLevel?SchoolLevelId=${SchoolLevelId}`, { headers })
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        },          
    },
}

export default SchoolLevel